import comp from "./RelatedConceptViewList";
export default comp;
